import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import Helmet from 'react-helmet';
import { useStaticQuery } from 'gatsby';
const SEOQuery = "4275725850";
export function SEO(_ref) {
  let {
    title
  } = _ref;
  const data = useStaticQuery(SEOQuery);
  const metaDescription = data.site.siteMetadata.description;
  const metaTitle = title || data.site.siteMetadata.title;
  const url = data.site.siteMetadata.siteUrl;
  const socialImage = data.defaultSocialImage || data.socialImage;
  const image = socialImage ? url + socialImage.childImageSharp.gatsbyImageData.images.fallback.src : null;
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: 'en'
    },
    title: metaTitle,
    meta: [{
      name: 'description',
      content: metaDescription
    }, {
      property: 'og:title',
      content: metaTitle
    }, {
      property: 'og:url',
      content: url
    }, {
      property: 'og:description',
      content: metaDescription
    }, {
      property: 'og:type',
      content: 'website'
    }].concat(_toConsumableArray(image ? [{
      property: 'og:image',
      content: image
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:image:src',
      content: image
    }] : []), [{
      name: 'twitter:creator',
      content: data.site.siteMetadata.author
    }, {
      name: 'twitter:title',
      content: metaTitle
    }, {
      name: 'twitter:description',
      content: metaDescription
    }])
  });
}